import { treeToArray } from "@opendash/core/dist/helper/arrayToTree";
import { useMemo } from "react";
import { useSourceTreeSelectData } from "../../../_shared";

/**
 * Returns the ids of the source and all its children as flat array
 * @param id the id of the root source
 * @returns the ids of the source and all its children
 */
export const useSourceWithChildren = (id: string) => {
  const data = useSourceTreeSelectData();

  const ids = useMemo(() => {
    if (!data || !id) return [];
    const flat = treeToArray(data ?? [], (d) => d.children);
    const selected = flat.find((d) => d.value === id);
    if (selected) {
      const flatIds = treeToArray([selected], (d) => d.children).map(
        (d) => d.value
      );
      return flatIds;
    }
    return [];
  }, [data, id]);

  return ids;
};
